import { messages } from '../translate/languages'
import { createContext } from 'react'

type Lang = 'en' | 'es' | 'pt-BR'

export const createI18nContext = () => {
  let lang: Lang = document.documentElement.lang as Lang

  if (!['en', 'es'].includes(lang)) lang = 'pt-BR'

  return createContext(messages[lang])
}

export const I18nContext = createI18nContext()
